<template>
  <div v-if="$company.created_by_company.customization_enabled || $company.customization_enabled">
    <img
      :src="($company.created_by_company.customization_enabled && $company.created_by_company.logo) || ($company.customization_enabled && $company.logo)"
      :alt="($company.created_by_company.customization_enabled && $company.created_by_company.displayname ) || ($company.customization_enabled && $company.displayname)"
      class="h-9 lg:h-16 w-auto"
    />
  </div>
  <img v-else :src="fallbackLogo" :alt="fallbackAlt" class="h-9 lg:h-16 w-auto" />
</template>

<script>
import defaultLogo from '@/assets/logo-cg-is-now-lc.svg'
import logoNis2 from '@/assets/logo-cg-nis2.png'
import logoNis2pa from '@/assets/logo-cg-nis2pa.png'
import logoDora from '@/assets/logo-cg-dora.png'
import { CyberGuru } from '@/common/constants'

const boardLogoMap = {
  1: logoNis2,
  2: logoNis2pa,
  3: logoDora,
}

export default {
  data() {
    return { defaultLogo }
  },
  computed: {
    boardType() {
      return this.$company?.company_options?.board_training_type_company?.value
    },
    fallbackLogo() {
      return boardLogoMap[this.boardType] || this.defaultLogo
    },
    fallbackAlt() {
      return boardLogoMap[this.boardType] ? this.$methods.companyDisplayName(this.$company) : CyberGuru.Name
    },
  },
}
</script>
